// SPDX-License-Identifier: MIT
// Durable localId→cloudId map for desktop ↔ cloud sync, backed by syncmap.json
// via the Rust get_syncmap/set_syncmap commands (mirrors the other local stores).
import { tauriInvoke } from './tauri';

export async function loadSyncMap(): Promise<Record<string, string>> {
  const raw = await tauriInvoke()('get_syncmap');
  if (typeof raw !== 'string' || raw.length === 0) return {};
  try {
    const obj = JSON.parse(raw) as Record<string, string>;
    return obj && typeof obj === 'object' ? obj : {};
  } catch {
    return {};
  }
}

export async function saveSyncMap(map: Record<string, string>): Promise<void> {
  await tauriInvoke()('set_syncmap', { json: JSON.stringify(map) });
}
